import React from 'react';
import './Policy.css';
import { Link } from 'react-router-dom';

const Policy = () => {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <Link to="/" className="policy-back-btn">← На главную</Link>
        
        <h1>Политика обработки персональных данных</h1>
        <p className="policy-date">Дата последнего обновления: 30 апреля 2026 г.</p>

        <section>
          <h2>1. Общие положения</h2>
          <p>Настоящая Политика определяет порядок обработки технических данных пользователей сайта alenabeauty.beauty. Обработка данных осуществляется в соответствии с Федеральным законом № 152-ФЗ «О персональных данных».</p>
        </section>

        <section>
          <h2>2. Какие данные собираются</h2>
          <p>Сайт обрабатывает следующие технические данные, необходимые для функционирования сервиса Яндекс.Метрика:</p>
          <ul>
            <li>IP-адрес (в обезличенном виде);</li>
            <li>тип браузера, устройства и операционной системы;</li>
            <li>данные о посещаемости (источник перехода, просмотренные страницы, время на сайте).</li>
          </ul>
          <p>Также могут собираться данные из форм на сайте (например, имя, email при заполнении заявки).</p>
          <p><strong>Правовое основание:</strong> обработка данных осуществляется на основании п. 5 ч. 1 ст. 6 Федерального закона № 152-ФЗ (обработка необходима для исполнения договора, стороной которого является субъект персональных данных) и/или на основании вашего согласия, полученного при использовании сайта (ст. 9 ФЗ-152-ФЗ).</p>
        </section>

        <section>
          <h2>3. Зачем нужна Яндекс.Метрика</h2>
          <p>Яндекс.Метрика используется для:</p>
          <ul>
            <li>анализа популярности разделов сайта;</li>
            <li>понимания географии и источников трафика;</li>
            <li>улучшения качества контента и удобства сайта.</li>
          </ul>
          <p>Все данные собираются в обезличенном виде.</p>
        </section>

        <section>
          <h2>4. Яндекс.Отзывы</h2>
          <p>На сайте размещен виджет Яндекс.Отзывы. Просмотр отзывов через виджет регулируется <a href="https://yandex.ru/legal/confidential/" target="_blank" rel="noopener noreferrer">Политикой конфиденциальности Яндекса</a>. Сам виджет не собирает личную информацию непосредственно на сайте.</p>
        </section>

        <section>
          <h2>5. Файлы cookie</h2>
          <p>Сайт использует файлы cookie для обеспечения работы аналитики. Вы можете отказаться от использования cookie, отключив их в настройках вашего браузера, либо установив <a href="https://yandex.ru/support/metrica/general/opt-out.html" target="_blank" rel="noopener noreferrer">расширение для отказа от сбора данных Яндекс.Метрикой</a>.</p>
        </section>

        <section>
          <h2>6. Ответственность и контакты</h2>
          <p>Владелец сайта принимает следующие меры для защиты данных: шифрование передаваемых данных, ограничение доступа к базам данных, регулярное обновление ПО, проведение внутренних аудитов безопасности.</p>
          <p>По вопросам обработки персональных данных или для направления запросов субъектов ПД вы можете связаться со мной по адресу: <a href="mailto:alenatrochina0606@yandex.ru">alenatrochina0606@yandex.ru</a>.</p>
        </section>

        <section>
          <h2>7. Ваше согласие</h2>
          <p>Продолжая использовать сайт, вы выражаете своё согласие на автоматизированную обработку технических данных (cookies) в соответствии с настоящей Политикой. Если вы не согласны с условиями, пожалуйста, покиньте сайт или отключите использование файлов cookie в настройках браузера.</p>
        </section>

        <section>
          <h2>8. Права субъекта персональных данных</h2>
          <p>Субъект персональных данных имеет право:</p>
          <ul>
            <li>на доступ к своим данным;</li>
            <li>на исправление неточных данных;</li>
            <li>на удаление данных (при наличии оснований);</li>
            <li>на ограничение обработки;</li>
            <li>на отзыв согласия;</li>
            <li>на обжалование действий оператора.</li>
          </ul>
          <p>Для реализации этих прав обратитесь по адресу: <a href="mailto:alenatrochina0606@yandex.ru">alenatrochina0606@yandex.ru</a>.</p>
        </section>

        <div className="policy-footer">
          <p>© 2026 alenabeauty.beauty — мастер бровист Алена Трошина</p>
        </div>
      </div>
    </div>
  );
};

export default Policy;